import type {NotificationPermissionState} from "@/lib/notification-permission";

// A browser tab has no notification permission worth reading here. The web build registers no push
// device (see lib/push-notifications.web.ts), so nothing is ever delivered to this browser and the
// Notification API's own permission — which expo-notifications does not implement for web anyway —
// would say nothing about whether the user's PHONE will buzz.
//
// The settings switch is still meaningful on web: it is a per-user setting that governs delivery to
// the user's registered devices, not to the tab it is toggled in. So the honest web answer is
// `unavailable` — the switch works, and there is no OS-level warning to show about it.

export async function getNotificationPermissionState(): Promise<NotificationPermissionState> {
    return "unavailable";
}
